(function () {
  'use strict';

  angular.module('wsLrs.services').factory("CSVParserRegistry", [function () {
    return {
      _parserMap: {
        'generic': '/group-import'
      },
      register: function register(parserMap) {
        var self = this;
        angular.forEach(parserMap, function (value, parserName) {
          self._parserMap[parserName] = value;
        });
      },
      getParserMap: function getParserMap() {
        return this._parserMap;
      },
      getParser: function getParser(parserName) {
        return this._parserMap[parserName];
      }
    };
  }]);
})();
